'use client';
import Script from "next/script";
import { useCallback, useEffect } from "react";

export default function GemEmbed({
  primaryHeading,
}: {
  primaryHeading?: string;
}) {
  const initGem = useCallback(async () => {
    if (typeof window !== 'undefined') {
      (window as any).__gemJobBoardUrl = 'https://jobs.gem.com/hellobabs-ai';
    }
  }, []);

  useEffect(() => {
    initGem();
  }, [initGem]);

  return (
    <div className="bg-beige gem-embed-container min-h-[calc(100dvh-var(--header-height))]">
      <Script src="https://jobs.gem.com/gem/embed"  />

      {primaryHeading && (
        <h1 className="margin">{primaryHeading}</h1>
      )}
      <div id="gem_job_board_embed" />
    </div>
  )
};
